'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculateNodeScore;

var _felaUtils = require('fela-utils');

function getRuleScore(baseScore) {
  var media = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var mediaQueryOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (media.length === 0) {
    return baseScore;
  }

  var mediaIndex = mediaQueryOrder.indexOf(media) + 1;

  if (mediaIndex) {
    return baseScore + mediaIndex * 2;
  }

  return 9999;
}

function calculateNodeScore(_ref, mediaQueryOrder) {
  var type = _ref.type,
      support = _ref.support,
      media = _ref.media;

  switch (type) {
    case _felaUtils.FONT_TYPE:
      return 0;

    case _felaUtils.STATIC_TYPE:
      return 1;

    case _felaUtils.KEYFRAME_TYPE:
      return 2;

    case _felaUtils.RULE_TYPE:
      return getRuleScore(support ? 4 : 3, media, mediaQueryOrder);

    default:
      // TODO: warning
      return 9999;
  }
}